import React from "react";
import '../styles/FormInput.css';
import { Select } from 'antd';

const FormSelect = (props) => {

    return (
        <div className="form-input-container">
            <div className="form-label">
                {props.label}{props.mandatory ? <span className="mandatory">*</span> : <></>}
            </div>
            <div className={props.buttonLabel ? "input-field-container margin-r-10" : "input-field-container"}>
                <Select placeholder={props.placeholder ? props.placeholder : ''} showSearch optionFilterProp="label" defaultValue={null}  disabled={props.disabled ? props.disabled : false}
                    options={props.options || []} value={props.value ? props.value : null} onChange={(v) => { props.onchange(v) }}/>
            </div>
        </div>
    )
}
export default FormSelect;